"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.concatUrl = void 0;
// Custom path join code to work both on node & browser
// Ref: https://stackoverflow.com/questions/29855098/is-there-a-built-in-javascript-function-similar-to-os-path-join
const joinPath = (...paths) => {
    return paths
        .map((part, index) => {
        if (index === 0) {
            return part.trim().replace(/[\\/]*$/g, '');
        }
        else {
            return part.trim().replace(/(^[\\/]*|[\\/]*$)/g, '');
        }
    })
        .filter((x) => x.length)
        .join('/');
};
/**
 * Concatenates a list of paths to a base URL
 * @param base Base URL string
 * @param paths List of paths to concatenate
 * @returns Concatenated URL object
 */
const concatUrl = (base, ...paths) => {
    const url = new URL(base);
    const newPath = joinPath(...[url.pathname, ...paths]);
    return new URL(newPath, url.origin);
};
exports.concatUrl = concatUrl;
//# sourceMappingURL=functions.js.map